class SessionStorage {
  static buildKey(name) {
    return `mira_${name}`;
  }

  static setItem(key, value) {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  static getItem(key) {
    const value = sessionStorage.getItem(key);
    if (!value) return null;

    try {
      return JSON.parse(value);
    } catch {
      return null;
    }
  }

  static removeItem(key) {
    sessionStorage.removeItem(key);
  }

  static clear() {
    sessionStorage.clear();
  }

  static forEach(cb) {
    Object.keys(sessionStorage).forEach((key) => {
      const value = SessionStorage.getItem(key);
      cb(value, key);
    });
  }
}

export default SessionStorage;
